import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import ReactPlayer from 'react-player/lazy';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import { mergeStyles, validate } from 'wix-rich-content-common';
import schema from './data-schema.json';
import styles from './styles/video-viewer.scss';
var _React_Component;
class VideoViewer extends (_React_Component = React.Component) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.componentData, this.props.componentData)) {
            validate(nextProps.componentData, schema);
        }
    }
    render() {
        // Omitting children here since passing children to ReactPlayer causes it to call
        // its own version of isEqual infinitely, triggering a "Max call stack exceeded error"
        const { componentData: { src } } = this.props;
        if (!ReactPlayer.canPlay(src)) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(ReactPlayer, {
            controls: true,
            config: {
                youtube: {
                    playerVars: {
                        fs: 0
                    }
                }
            },
            className: classNames(this.styles.video_player),
            url: src,
            width: '100%',
            height: '100%'
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "styles", void 0);
        validate(props.componentData, schema);
        this.styles = mergeStyles({
            styles: styles,
            theme: props.theme || {}
        });
    }
}
_define_property(VideoViewer, "propTypes", {
    componentData: PropTypes.object.isRequired,
    theme: PropTypes.object,
    onReady: PropTypes.func,
    onStart: PropTypes.func,
    controls: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string
});
_define_property(VideoViewer, "defaultProps", {
    width: '100%',
    height: '100%',
    controls: true
});
export default VideoViewer;
